import { useQuery } from "@tanstack/react-query";
import * as api from "./api";

/*
 * useCopilotRecommendation Query
 *
 * Unified hook for getting recommendations across different report types.
 * Handles attention, memory, and emotion recommendations.
 * QueryKey: [projectId, studyId, "copilot", key, reportType, metric]
 */
export const useCopilotRecommendation = (
  projectId: string,
  studyId: string,
  key: string,
  reportType: "attention" | "memory" | "emotion",
  metric?: string, // Only needed for attention
  type?: string, // Only needed for scene studies
) => {
  return useQuery({
    queryKey: [projectId, studyId, "copilot", key, reportType, metric, type],
    queryFn: () => {
      // Baseded on report type, call the appropriate API
      switch (reportType) {
        case "attention":
          if (!metric) {
            throw new Error("Metric is required for attention recommendations");
          }
          return api.getAttentionRecommendation(projectId, studyId, key, metric, type);
        case "memory":
          return api.getMemoryRecommendation(projectId, studyId, key);
        case "emotion":
          return api.getEmotionRecommendation(projectId, studyId, key);
        default:
          throw new Error(`Unsupported report type: ${reportType}`);
      }
    },
  });
};
